<tax-page-header [titleText]="kkmRegisterMethodName"></tax-page-header>

<div class="ui-kit-content-container" *taxPreloader="!processForm">
  <!--TODO: fix $any-->
  <tax-kkm-reg-form
    *ngIf="processForm?.formKey === 'kkm-registration-manually'"
    [kkmForm]="$any(processForm?.fields)"
    [isChangingOfd]="isChangingOfd"
    (continueProcess)="continueProcess($event)"
  ></tax-kkm-reg-form>
  <!--TODO: fix $any-->
  <tax-kkm-sign
    *ngIf="processForm?.formKey === 'kkm-inis-register-sing-kkm-annex'"
    [kkmForm]="$any(processForm)"
    (goBack)="goToFirstStep()"
  ></tax-kkm-sign>
</div>
